import React, { Component, PropTypes } from 'react';
import { autobind } from 'core-decorators';
import classNames from 'classnames';
import escapeRegex from 'escape-string-regexp';
import { remove as removeDiacritics } from 'diacritics';

import './styles.scss';


class Result extends Component {

  static propTypes = {
    charger: PropTypes.shape({
      pk: PropTypes.number,
      title: PropTypes.string,
      title_ascii: PropTypes.string,
      is_supercharger: PropTypes.bool,
    }).isRequired,
    onClick: PropTypes.func,
    search: PropTypes.string,
    selected: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    search: '',
    selected: false,
  };

  @autobind
  onClick(e) {
    this.props.onClick(e, this.props.charger.pk);
  }

  render() {
    const { charger, search, selected } = this.props;
    const re = new RegExp(`(^|\\s)(${escapeRegex(removeDiacritics(search))})`, 'i');
    const match = (charger.title_ascii || charger.title).match(re);
    return (
      <button
        onClick={this.onClick}
        className={classNames('list-group-item', 'list-group-item-action', {
          supercharger: charger.is_supercharger,
          'destination-charger': !charger.is_supercharger,
          active: selected,
        })}
        styleName='result'
        title={charger.title}
      >

        { match ?
          <span>
            { charger.title.substr(0, match.index + match[1].length) }
            <strong>
              { charger.title.substr(match.index + match[1].length, match[2].length) }
            </strong>
            { charger.title.substr(match.index + match[1].length + match[2].length) }
          </span>
        : charger.title }

      </button>
    );
  }

}

export default Result;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/Header/Search/Result.jsx